import { render, staticRenderFns } from "./uploadPhones.vue?vue&type=template&id=0c1f1572"
import script from "./uploadPhones.vue?vue&type=script&lang=js"
export * from "./uploadPhones.vue?vue&type=script&lang=js"
import style0 from "./uploadPhones.vue?vue&type=style&index=0&id=0c1f1572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports